import { compose } from 'recompose'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import CustomSelect from '../../../elements/Select/CustomSelect'
import React from 'react'

const Custom = compose(
  withUrlFetch({
    name: 'employees',
    url: 'employees/dropdown/?status=Active',
    cache: true,
  }),
  withSpinning,
)(CustomSelect)

function EmployeeSelect(props) {
  return (
    <Custom
      placeholder={'Select an Employee'}
      keyAtr={'_id'}
      valueAtr={'name'}
      style={{ width: '100%' }}
      {...props}
    />
  )
}

export default EmployeeSelect
